export const PLUGIN_NAME = 'shopware';
export const COMPONENT_PREFIX = 'kel-shopware-';
// emitted after a guest registers, with { customerId, email }, e.g. to identify them in analytics
export const GUEST_REGISTERED_EVENT = `plugin:${PLUGIN_NAME}:guest:registered`;
export const EVENT_NAMES = {
  add_to_cart: 'add_to_cart',
  view_item: 'view_item',
  view_item_list: 'view_item_list',
  begin_checkout: 'begin_checkout'
};

// Line item additionalData key holding the subscription start date, set when a subscription is
// added with the after Christmas switch on (see ProductVariants)
export const FUTURE_START_DATE_KEY = 'future_start_date';
